var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorderTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 910,
    viewBox: "0 0 601 910",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.5 -11V277C426.5 285.837 419.337 293 410.5 293H16.5C7.66344 293 0.5 300.163 0.5 309V893C0.5 901.837 7.66344 909 16.5 909H611",
    stroke: "black",
    strokeDasharray: "7 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderTwo);
export default __webpack_public_path__ + "static/media/borderTwo.3c599d97b9b9c2388144c189f727be0c.svg";
export { ForwardRef as ReactComponent };